export default __webpack_public_path__ + "static/media/CertificationWhiteIcon.92f55961.svg";